import { faCarBuilding, faCity, faHouse, faTrees } from '@fortawesome/pro-regular-svg-icons'
import {
  faCarBuilding as solidFaCarBuilding,
  faCity as solidFaCity,
  faHouse as solidFaHouse,
  faTrees as solidFaTrees,
} from '@fortawesome/pro-solid-svg-icons'
import { Box, Typography } from '@material-ui/core'
import { ChipSelector } from '@scoir/college-search'

import { LOCALE_OPTIONS, LocaleOption } from '../../types'

interface FilterLocaleProps {
  locale: LocaleOption[]
  setLocale: (locales: LocaleOption[]) => void
  enabled: boolean
}

const FilterLocale = ({ locale, setLocale, enabled }: FilterLocaleProps) => {
  // sorts empty option last so Unknown isn't at the top
  const sortedLocaleOptions = [...LOCALE_OPTIONS].sort((a, b) => {
    if (a === '') return 1
    if (b === '') return -1
    return a.localeCompare(b)
  })
  const getIcon = (option: LocaleOption, selected = false) => {
    switch (option) {
      case 'City: Large':
      case 'City: Mid-size':
      case 'City: Small':
        return selected ? solidFaCity : faCity
      case 'Town: Distant':
      case 'Town: Fringe':
      case 'Town: Remote':
        return selected ? solidFaHouse : faHouse
      case 'Rural: Distant':
      case 'Rural: Fringe':
      case 'Rural: Remote':
        return selected ? solidFaTrees : faTrees
      case 'Suburb: Large':
      case 'Suburb: Mid-size':
      case 'Suburb: Small':
        return selected ? solidFaCarBuilding : faCarBuilding
      default:
        return undefined
    }
  }
  const localeOptions = sortedLocaleOptions.map((option) => ({
    label: option ? option : 'Unknown',
    value: option ? option : '',
    icon: getIcon(option),
    selectedIcon: getIcon(option, true),
    disabled: !enabled,
  }))
  const selectedLocaleOptions = locale.map((option) => ({
    label: option ? option : 'Unknown',
    value: option ? option : '',
    icon: getIcon(option, true),
    disabled: !enabled,
  }))

  return (
    <Box
      display="flex"
      flexDirection="column"
      gridGap={16}
    >
      <Typography
        component="div"
        variant="subtitle2"
      >
        Locale
      </Typography>
      <ChipSelector
        options={localeOptions}
        selected={selectedLocaleOptions}
        onUpdateSelection={(values) => {
          const strippedSelectedValues: LocaleOption[] = values.map((option: { value: LocaleOption }) => option.value)
          setLocale(strippedSelectedValues)
        }}
      />
    </Box>
  )
}

export default FilterLocale
